var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvantage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10099_13650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66681V8.00014",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.0001V29.3335",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57324 6.57288L10.3466 10.3462",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6533 21.6533L25.4267 25.4266",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 16.0001H8.00033",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16.0001H29.3333",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57324 25.4268L10.3466 21.6534",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6533 10.3464L25.4267 6.57306",
    stroke: "#B068EE",
    strokeWidth: 4.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10099_13650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage3);
export default __webpack_public_path__ + "static/media/advantage-3.1164d4f12c9fd2ea67339919cd479564.svg";
export { ForwardRef as ReactComponent };